module.exports = __webpack_public_path__ + "static/searching-dc36b4c1e5c62fbb7650d48b694cb018.gif";